import { IntlShape, MessageDescriptor } from 'react-intl';

import { templateSpecialtyMessages } from '../config/i18n';

export const getSpecialtyLabel = (
  formatMessage: IntlShape['formatMessage'],
  specialty?: string | null,
): string => {
  if (!specialty) {
    return '';
  }

  const message = (
    templateSpecialtyMessages as Record<string, MessageDescriptor>
  )[specialty];

  return message ? formatMessage(message) : specialty;
};
